<template>
  <div class="container">
    <div class="login-box" v-show="success">
      <div class="title">LAOT</div>
      <div class="body">登出成功！</div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useRouter} from 'vue-router';
import {tokenManager} from '@/util/token';
import {request} from '@/util/request';
import {toLogin} from '@/util/login';

export default defineComponent({
  name: 'Logout',
  data() {
    return {
      success: false,
    };
  },
  setup() {
    return {
      router: useRouter(),
    };
  },
  async mounted() {
    const res = await request('/management/login/logout', null, {
      noNeedLogin: true,
    });
    if (res) {
      tokenManager.del();
      this.success = true;
    }
  },
  methods: {
    retry() {
      toLogin(true);
    },
  },
});
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background: #ececec;
  padding-top: 150px;

  .login-box {
    width: 500px;
    background: #fff;
    margin: 0 auto;

    .title {
      padding: 20px;
      font-size: 16px;
      border-bottom: 1px solid $color-content-border;
    }

    .body {
      padding: 40px;
      text-align: center;
    }

    .line {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;
      padding-right: 20px;

      .label {
        width: 60px;
      }
    }

    .btn-group {
      border-top: 1px solid $color-content-border;
      padding: $spacing-medium;
    }
  }
}
</style>
